import CameraIcon from "assets/images/CameraIcon";
import InsuranceCard from "assets/images/insurance-card.svg";
import Pharmacy from "assets/images/pharmacy.svg";
import TaxReport from "assets/images/tax-report.svg";
import TransferIn from "assets/images/transfer-in.svg";
import {parse, format} from "date-fns";
import {useState} from "react";

import AlertModal from "components/AlertModal";
import AppointmentIcon from "components/AppointmentIcon";
import Button from "components/Button";
import CardLink from "components/CardLink";
import ConfirmRefillRequest from "components/ConfirmRefillRequest";
import DateInput, {DateString} from "components/DateInput";
import DatePicker from "components/DatePicker";
import DatePickerModal from "components/DatePickerModal";
import Map from "components/Map";
import MedicationsFilterModal, {
  FilterOptions,
} from "components/MedicationsFilterModal";
import MobileNavigationHeader from "components/MobileNavigationHeader";
import PageTitle from "components/PageTitle";
import RadioButton from "components/RadioButton";
import RefillPlacedModal from "components/RefillPlacedModal";
import SearchBar from "components/SearchBar";
import SegmentedControl from "components/SegmentedControl";
import Select from "components/Select";
import StatusDisplay from "components/StatusDisplay";
import StyledModal from "components/StyledModal";
import Switch from "components/Switch";
import TextArea from "components/TextArea";
import TextInput from "components/TextInput";
import TimePicker from "components/TimePicker";
import TimePickerModal from "components/TimePickerModal";

import * as models from "liberty-core/api/models";

import {useAlert} from "lib/alert";

import styles from "./DemoPage.module.css";

export default function DemoPage() {
  const [value, setValue] = useState("");

  const [checked, setChecked] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [multilineText, setMultilineText] = useState("");
  const [password, setPassword] = useState("");
  const [telephoneNum, setTelephoneNum] = useState("");
  const [switchChecked, setSwitchChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showStyledModal, setShowStyledModal] = useState(false);
  const [searchBarValue, setSearchBarValue] = useState("");
  const [datePicked, setDatePicked] = useState<Date>();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [errorText, setErrorText] = useState("");
  const [selectedTime, setSelectedTime] = useState<models.TimeString>("");
  const [dateInputDate, setDateInputDate] = useState<DateString>("");
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filters, setFilters] = useState<FilterOptions>({
    readyForRefill: false,
    onFile: false,
    inProgress: false,
    requiresRenewal: false,
    scheduled: false,
    readyForPickup: false,
  });

  const [showDatePickerModal, setShowDatePickerModal] = useState(false);
  const [showRefillModal, setShowRefillModal] = useState(false);
  const [chosenDate, setChosenDate] = useState<Date>();
  const [showTimePickerModal, setShowTimePickerModal] = useState(false);
  const [chosenTime, setChosenTime] = useState<models.TimeString>("");
  const [showConfirmRefillRequest, setShowConfirmRefillRequest] =
    useState(false);

  const [date, setDate] = useState<Date | undefined>(undefined);
  const [confirmTime, setConfirmTime] = useState<models.TimeString | undefined>(
    undefined,
  );
  const [comment, setComment] = useState("");
  const [showConfirmRefillRequest2, setShowConfirmRefillRequest2] =
    useState(false);
  const [date2, setDate2] = useState<Date | undefined>(undefined);
  const [confirmTime2, setConfirmTime2] = useState<
    models.TimeString | undefined
  >(undefined);
  const [comment2, setComment2] = useState("");

  const parsedTime = parse(selectedTime, "HH:mm", new Date());

  const medications = Array(2).fill({
    scriptNumber: 121212,
    imageUrl: "https://via.placeholder.com/229x125",
    name: "Amoxil 250mg Tablet",
    quantity: 30,
  });
  const alert = useAlert();

  return (
    <div className={styles.pageContainer}>
      <MobileNavigationHeader backTo="" />
      <PageTitle>Demo Page</PageTitle>

      <SegmentedControl
        tabs={["Upcoming", "Past"]}
        currentIndex={currentIndex}
        onPress={(newIndex: number) => setCurrentIndex(newIndex)}
      />

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Status Display</h2>
        <StatusDisplay
          labels={[
            "Scheduled",
            "Processing",
            "Ready for Pickup",
            "Really Ready",
          ]}
          current={0}
        />
        <StatusDisplay
          labels={["Ready for Pickup", "Processing", "Test", "Really Ready"]}
          current={0}
        />
        <StatusDisplay
          labels={["Scheduled", "Processing", "Ready for Pickup"]}
          current={1}
        />
        <StatusDisplay
          labels={["Scheduled", "Processing", "Ready for Pickup"]}
          current={2}
        />
        <StatusDisplay
          labels={["Scheduled", "Processing", "Ready for Pickup"]}
          current={1}
          error={true}
        />
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Search Bar</h2>
        <SearchBar
          prompt={
            "Search for components Search for components Search for components Search for components Search for components Search for components Search for components Search for components"
          }
          value={searchBarValue}
          onChange={setSearchBarValue}
        />
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Text</h2>
        <div className={styles.seven}>700 weight</div>
        <div className={styles.six}>600 weight</div>
        <div className={styles.five}>500 weight</div>
        <div className={styles.four}>400 weight</div>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Button</h2>
        <Button onClick={() => console.log("button clicked")}>
          Filled button
        </Button>
        <Button onClick={() => console.log("button clicked")} disabled={true}>
          Disabled button
        </Button>
        <Button
          onClick={() => console.log("button clicked")}
          variant="unfilled"
        >
          Unfilled button
        </Button>
        <Button
          onClick={() => console.log("button clicked")}
          variant="unfilled"
          disabled={true}
        >
          Unfilled disabled button
        </Button>
        <Button
          onClick={() => console.log("button clicked")}
          variant="unfilled"
          iconLeft={(color: string) => <CameraIcon color={color} />}
        >
          Icon button
        </Button>
        <Button
          onClick={() => console.log("button clicked")}
          variant="unfilled"
          disabled={true}
          iconLeft={(color: string) => <CameraIcon color={color} />}
        >
          Disabled icon button
        </Button>
        <Button
          onClick={() => console.log("button clicked")}
          loading={true}
          variant="filled"
          disabled={false}
        >
          Demo Loader
        </Button>
        <Button
          onClick={() => console.log("button clicked")}
          loading={true}
          variant="unfilled"
          disabled={false}
          iconLeft={(color: string) => <CameraIcon color={color} />}
          iconRight={(color: string) => <CameraIcon color={color} />}
        >
          Demo Icon Loader
        </Button>
        <Button
          onClick={() => console.log("button clicked")}
          loading={true}
          variant="minimal"
          disabled={false}
        >
          Demo Minimal Loader
        </Button>
        <Button onClick={() => console.log("button clicked")} variant="minimal">
          Minimal button
        </Button>
        <Button
          onClick={() => console.log("button clicked")}
          variant="minimal"
          disabled={true}
        >
          Disabled minimal button
        </Button>
        <Button
          onClick={() => console.log("button clicked")}
          to="/"
          variant="filled"
        >
          Link-button (to home)
        </Button>
        <Button
          onClick={() => console.log("button clicked")}
          to="/"
          variant="unfilled"
        >
          Unfilled link-button (to home)
        </Button>
        <Button href="tel:1234567890">href button</Button>
        <Button variant="unfilled" href="tel:1234567890">
          href button unfilled
        </Button>
        <Button variant="minimal" href="tel:1234567890">
          href button minimal
        </Button>
        <Button loading href="tel:1234567890">
          href button loading
        </Button>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>AlertModal</h2>
        <Button onClick={() => setShowModal(true)} variant="filled">
          Show Modal
        </Button>
        <AlertModal
          title={"Whoops!"}
          message={
            "Passwords do not match, please re-enter passwords and try again"
          }
          visible={showModal}
          onClickConfirm={() => setShowModal(false)}
        />
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>StyledModal</h2>
        <Button onClick={() => setShowStyledModal(true)}>
          Show Styled Modal
        </Button>
        <StyledModal
          visible={showStyledModal}
          title="Styled Modal"
          onRequestClose={() => setShowStyledModal(false)}
        >
          <p style={{margin: 0}}>
            Test message. Test message. Test message. Test message. Test
            message. Test message. Test message. Test message. Test message.
            Test message. Test message. Test message. Test message.
          </p>
        </StyledModal>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Switch</h2>
        <Switch checked={switchChecked} onChange={setSwitchChecked} />
      </section>

      <section className={styles.section} style={{alignItems: "stretch"}}>
        <h2 className={styles.sectionTitle}>TextInput</h2>
        <TextInput
          label="Username"
          type="text"
          value={username}
          onChange={(event) => setUsername(event.target.value)}
        />
        <TextInput
          label="Email"
          type="email"
          value={email}
          errorText={errorText}
          onChange={(event) => setEmail(event.target.value)}
        />
        <TextArea
          placeholder="Comments"
          value={multilineText}
          onChangeText={setMultilineText}
        />
        <Button
          variant="filled"
          onClick={() => {
            if (errorText === "") {
              setErrorText("Email is invalid");
            } else setErrorText("");
          }}
        >
          Toggle Error Text
        </Button>
        <TextInput
          label="Password"
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />
        <TextInput
          label="Telephone Number"
          type="tel"
          value={telephoneNum}
          onChange={(event) => setTelephoneNum(event.target.value)}
        />
        <Button onClick={() => console.log(telephoneNum)}>
          Check Telephone Number
        </Button>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>RadioButton</h2>
        <button onClick={() => setChecked((prev) => !prev)}>
          click me to click radio button.
        </button>
        <RadioButton checked={checked} />
      </section>

      <section>
        <h2>Switch (Dropdown)</h2>
        <Select
          options={[
            {label: "Option 1", value: "option-1"},
            {label: "Option 2", value: "option-2"},
            {label: "Option 3", value: "option-3"},
            {label: "Option 4", value: "option-4"},
            {label: "Option 5", value: "option-5"},
            {label: "Option 6", value: "option-6"},
            {label: "Option 7", value: "option-7"},
            {label: "Option 8", value: "option-8"},
            {label: "Option 9", value: "option-9"},
            {label: "Option 10", value: "option-10"},
            {label: "Option 11", value: "option-11"},
            {label: "Option 12", value: "option-12"},
            {label: "Option 13", value: "option-13"},
            {label: "Option 14", value: "option-14"},
            {label: "Option 15", value: "option-15"},
          ]}
          value={value}
          onChange={setValue}
          placeholder="Select an option"
        />
      </section>

      <section>
        <h2>Date Picker</h2>
        <DatePicker datePicked={datePicked} onDateChange={setDatePicked} />
      </section>

      <section>
        <h2>Card Links</h2>
        <div className={styles.cardLinks}>
          <CardLink cardLabel="Pharmacy" cardImageLink={Pharmacy} to="/" />
          <CardLink
            cardLabel="Insurance Card"
            cardImageLink={InsuranceCard}
            to="/"
          />
          <CardLink cardLabel="Tax Report" cardImageLink={TaxReport} to="/" />
          <CardLink cardLabel="Transfer In" cardImageLink={TransferIn} to="/" />
        </div>
      </section>
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>TimePicker</h2>
        <Button
          onClick={() => {
            if (selectedTime === "") return;
            alert({
              title: "Chosen Time",
              message:
                "Unformatted is " +
                selectedTime +
                " and formatted is " +
                format(parsedTime, "p"),
            });
          }}
        >
          Push to See What Time is Selected
        </Button>
        <TimePicker
          allTimes={[
            "09:00",
            "09:30",
            "10:00",
            "10:30",
            "11:00",
            "11:30",
            "12:00",
            "12:30",
            "13:00",
            "13:30",
            "14:00",
            "14:30",
            "15:00",
            "15:30",
            "16:00",
            "16:30",
            "17:00",
          ]}
          availableTimes={[
            "10:30",
            "12:00",
            "13:30",
            "14:30",
            "15:30",
            "17:00",
          ]}
          selectedTime={selectedTime}
          onClick={(time: models.TimeString) => setSelectedTime(time)}
        />
      </section>
      <section>
        <h2>Map</h2>
        <Map
          center={{lat: 30.2867197, lng: -97.7525458}}
          className={styles.map}
        />
      </section>

      <section>
        <h2>Date Picker Modal</h2>
        <Button onClick={() => setShowDatePickerModal(true)}>
          Click to open date picker modal
        </Button>
        <h4>{`Chosen Date: ${chosenDate}`}</h4>
        <DatePickerModal
          visible={showDatePickerModal}
          onClickConfirm={(dateChosen) => {
            setShowDatePickerModal(false);
            setChosenDate(dateChosen);
          }}
          onClickCancel={() => setShowDatePickerModal(false)}
          datePicked={chosenDate ?? new Date(2022, 6, 14)}
          availableDates={Array(30)
            .fill(0)
            .map((_, i) => new Date(2022, 6, i + 1))}
        />
      </section>

      <section>
        <h2>Time Picker Modal</h2>
        <Button onClick={() => setShowTimePickerModal(true)}>
          Click to open time picker modal
        </Button>
        <h4>{`Chosen Time: ${chosenTime}`}</h4>
        <TimePickerModal
          allTimes={[
            "09:00",
            "09:30",
            "10:00",
            "10:30",
            "11:00",
            "11:30",
            "12:00",
            "12:30",
            "13:00",
            "13:30",
            "14:00",
            "14:30",
            "15:00",
            "15:30",
            "16:00",
            "16:30",
            "17:00",
          ]}
          availableTimes={[
            "10:30",
            "12:00",
            "13:30",
            "14:30",
            "15:30",
            "17:00",
          ]}
          onClickConfirm={(time: models.TimeString) => {
            setChosenTime(time);
            setShowTimePickerModal(false);
          }}
          onClickCancel={() => setShowTimePickerModal(false)}
          visible={showTimePickerModal}
        />
      </section>

      <section>
        <h2>Appointment Icon</h2>
        <AppointmentIcon isSelected={true} hasUpcoming={true} />
      </section>

      <section>
        <h2>Date Input</h2>
        <DateInput value={dateInputDate} onChangeDate={setDateInputDate} />
        <span>{`date chosen: ${dateInputDate}`}</span>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Medications Filter Modal</h2>
        <Button onClick={() => setShowFilterModal(true)} variant="filled">
          Show Filter Modal
        </Button>
        <MedicationsFilterModal
          visible={showFilterModal}
          filterOptions={filters}
          onClickConfirm={setFilters}
          onClickCancel={() => setShowFilterModal(false)}
        />
      </section>
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Refill Placed Modal</h2>
        <Button onClick={() => setShowRefillModal(true)} variant="filled">
          Show Refill Placed Modal
        </Button>
        <RefillPlacedModal
          medicationList={medications}
          refillResponse={[]}
          visible={showRefillModal}
          onClickClose={() => setShowRefillModal(false)}
        />
      </section>
      <section>
        <h2>Alert Modal hook</h2>
        <Button
          onClick={() =>
            alert({title: "Alert Modal", message: "using useAlert hook"})
          }
        >
          Show Modal
        </Button>
        <Button
          onClick={() =>
            alert({
              title: "Alert Modal 2",
              message: "also using useAlert hook",
            })
          }
        >
          Show Modal 2
        </Button>
      </section>
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Confirm Refill Request</h2>
        <Button
          onClick={() => setShowConfirmRefillRequest(true)}
          variant="filled"
        >
          Show Confirm Refill Request
        </Button>
        <ConfirmRefillRequest
          visible={showConfirmRefillRequest}
          onClickCancel={() => setShowConfirmRefillRequest(false)}
          med={[
            {
              name: "Amoxil 250mg Tablet",
              quantity: 30,
            },
          ]}
          onPickDate={(newDate: Date) => {
            setDate(newDate);
          }}
          onPickTime={(newTime: models.TimeString) => {
            setConfirmTime(newTime);
          }}
          onComment={(commentChosen) => setComment(commentChosen)}
          datePicked={date}
          timePicked={confirmTime}
          comment={comment}
          onClickRequest={() => null}
        />
        <Button
          onClick={() => setShowConfirmRefillRequest2(true)}
          variant="filled"
        >
          Show Confirm Refill Request (Multiple Meds)
        </Button>
        <ConfirmRefillRequest
          visible={showConfirmRefillRequest2}
          onClickCancel={() => setShowConfirmRefillRequest2(false)}
          med={[
            {
              name: "Amoxil 250mg Tablet",
              quantity: 30,
            },
            {
              name: "Pravastatin Sodium",
              quantity: 60,
            },
          ]}
          onPickDate={(newDate: Date) => {
            setDate2(newDate);
          }}
          onPickTime={(newTime: models.TimeString) => {
            setConfirmTime2(newTime);
          }}
          onComment={(commentChosen) => setComment2(commentChosen)}
          datePicked={date2}
          timePicked={confirmTime2}
          comment={comment2}
          onClickRequest={() => null}
        />
      </section>
    </div>
  );
}
